import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { enumAttributeConverter } from '../enum-types';
import { getGlobalStyleSheets } from '../../global-styles';
import { AtlSpanPlaceholderProps } from './placeholders.props';

import * as PlaceholderTags from './placeholders.tagnames';
import { SpanPlaceholderSizes } from './placeholders.enums';

const sizes = {
    [SpanPlaceholderSizes.ExtraSmall]: "30",
    [SpanPlaceholderSizes.Smaller]: "50",
    [SpanPlaceholderSizes.Small]: "70",
    [SpanPlaceholderSizes.Medium]: "100",
    [SpanPlaceholderSizes.Large]: "170",
    [SpanPlaceholderSizes.Larger]: "220",
    [SpanPlaceholderSizes.ExtraLarge]: "250",
};

@customElement(PlaceholderTags.Span)
export class AtlSpanPlaceholder extends LitElement implements AtlSpanPlaceholderProps {

    declare size: SpanPlaceholderSizes;
    declare taller: boolean;
    declare glow: boolean;

    static properties = {
        size: { type: String, converter: enumAttributeConverter(SpanPlaceholderSizes, SpanPlaceholderSizes.Medium)  },
        taller: { type: Boolean },
        glow: { type: Boolean }        
    }

    constructor() {
        super();
        this.size = SpanPlaceholderSizes.Medium;
    }

    static styles = [
        ...getGlobalStyleSheets(),
        css`
            :host { line-height: 14px; }
            .glow { animation: placeholder-glow 2s ease-in-out infinite; }
        `
    ];

    render() {
        const spnClass = [ "placeholder" ];
        if (this.className) {
            spnClass.push(this.className);
        }

        if (this.glow) {
            spnClass.push("glow");
        }

        return html`
            <span
                class="${spnClass.join(' ')}"
                style="width: ${sizes[this.size]}px;${this.taller ? "height: 40px;" : ""}"
                part="placeholder-span"
            >
            </span>
        `;
    }
}